/**
 * The charts, fetched after the page around them is already readable.
 *
 * recharts is the largest single thing in this bundle — larger than React and
 * the router together — and `/today`, the first screen anybody opens, draws
 * two of them. Loaded with everything else it is a few hundred kilobytes that
 * has to arrive before the numbers *beside* the charts can paint, on a phone,
 * on whatever signal somebody has on a shoot. Loaded this way the tiles, the
 * lists and the counts are readable straight away and the charts fill in.
 *
 * The placeholder is the chart's own height rather than a spinner, so nothing
 * below moves when it lands. A page that reflows under a reader's thumb is
 * worse than one that waits.
 *
 * `LineChartMini` is deliberately not here: nothing imports it, so it is
 * already absent from the bundle, and wrapping it would only make it look used.
 */

import { Suspense, lazy, type ComponentProps } from 'react'

const Bar = lazy(() => import('./BarChartMini').then((m) => ({ default: m.BarChartMini })))
const Donut = lazy(() => import('./DonutChart').then((m) => ({ default: m.DonutChart })))

function Placeholder({ height }: { height: number | string }) {
  return <div aria-hidden style={{ height }} className="w-full animate-pulse rounded-xl bg-ink-50" />
}

export function BarChartMini(props: ComponentProps<typeof Bar>) {
  return (
    <Suspense fallback={<Placeholder height={props.height ?? 220} />}>
      <Bar {...props} />
    </Suspense>
  )
}

export function DonutChart(props: ComponentProps<typeof Donut>) {
  // 13rem, which is the `h-52` the real one sets on itself.
  return (
    <Suspense fallback={<Placeholder height="13rem" />}>
      <Donut {...props} />
    </Suspense>
  )
}
